// Single source of truth for ProjectStatus (mirrors backend enum ProjectStatus in
// Models/Project.cs). `index` MUST match the backend enum's numeric value. New
// JobNimbus/Engage stages were appended to the enum (indices 12–19) to keep existing
// rows stable, so the pipeline/display order here is given by ARRAY ORDER, not by index.

// Active pipeline, in workflow order (this is the job-board column order).
export const PROJECT_STATUSES = [
  { index: 0,  key: 'Lead',                   label: 'Lead',                     accent: '#6b7280' },
  { index: 19, key: 'PendingClaimInfo',       label: 'Pending Claim Info',       accent: '#a855f7' },
  { index: 25, key: 'ClaimFiledWaitingOnAdjuster', label: 'Claim Filed – Waiting on Adjuster', accent: '#a855f7' },
  { index: 24, key: 'AdjusterFollowUp',       label: 'Adjuster Follow Up',       accent: '#a855f7' },
  { index: 13, key: 'ApprovedWaitingOnScope', label: 'Approved – Waiting on Scope', accent: '#7c3aed' },
  { index: 20, key: 'Approved',               label: 'Approved',                 accent: '#7c3aed' },
  { index: 18, key: 'ReinspectionRequest',    label: 'Reinspection Request',     accent: '#9333ea' },
  { index: 17, key: 'PendingReinspection',    label: 'Pending Reinspection',     accent: '#9333ea' },
  { index: 1,  key: 'WriteEstimate',          label: 'Write Estimate',           accent: '#8b5cf6' },
  { index: 2,  key: 'PendingSignature',       label: 'Pending Signature',        accent: '#d97706' },
  { index: 3,  key: 'SignedContract',         label: 'Signed Contract',          accent: '#2563eb' },
  { index: 14, key: 'ScheduleJobs',           label: 'Schedule Jobs',            accent: '#0ea5e9' },
  { index: 15, key: 'OrderMaterials',         label: 'Order Materials',          accent: '#0284c7' },
  { index: 4,  key: 'PendingStartDate',       label: 'Pending Start',            accent: '#0891b2' },
  { index: 5,  key: 'JobsInProgress',         label: 'In Progress',              accent: '#4a6cf7' },
  { index: 16, key: 'AddWorkPending',         label: 'Add. Work Pending',        accent: '#4f46e5' },
  { index: 6,  key: 'JobCompleted',           label: 'Job Completed',            accent: '#16a34a' },
  { index: 21, key: 'JobCompletedNRR',        label: 'Job Completed – NRR',      accent: '#65a30d' },
  { index: 27, key: 'WarrantyRepairs',        label: 'Warranty Repairs',         accent: '#14b8a6' },
  { index: 28, key: 'WarrantyInteriorRepairs', label: 'Warranty – Interior Repairs', accent: '#14b8a6' },
  { index: 26, key: 'SubmitFinalInvoice',     label: 'Submit Final Invoice',     accent: '#d97706' },
  { index: 7,  key: 'PendingPayments',        label: 'Pending Payment',          accent: '#ca8a04' },
  { index: 23, key: 'PastDue',                label: 'Past Due',                 accent: '#dc2626' },
  { index: 11, key: 'SendWarranty',           label: 'Send Warranty',            accent: '#0d9488' },
];

// Terminal stages — hidden behind a toggle on the board.
export const TERMINAL_STATUSES = [
  { index: 10, key: 'PaidClosed',   label: 'Paid / Closed',    accent: '#15803d', terminal: true },
  { index: 22, key: 'LostSales',    label: 'Lost Sales',       accent: '#b91c1c', terminal: true },
  { index: 8,  key: 'Cancelled',    label: 'Cancelled',        accent: '#9ca3af', terminal: true },
  { index: 9,  key: 'LostFollowUp', label: 'Lost / Follow Up', accent: '#dc2626', terminal: true },
];

const ALL_STATUSES = [...PROJECT_STATUSES, ...TERMINAL_STATUSES];

// Numeric status (as the API returns it) → enum key name.
export const STATUS_KEY_BY_INDEX = Object.fromEntries(ALL_STATUSES.map((s) => [s.index, s.key]));

// Numeric status → human label.
export const STATUS_LABEL_BY_INDEX = Object.fromEntries(ALL_STATUSES.map((s) => [s.index, s.label]));

// Enum key → numeric status.
export const STATUS_INDEX_BY_KEY = Object.fromEntries(ALL_STATUSES.map((s) => [s.key, s.index]));

// Options for a <select> that sets a project's status ({ value, label }), pipeline
// order first then terminal stages.
export const STATUS_SELECT_OPTIONS = ALL_STATUSES.map((s) => ({ value: s.index, label: s.label }));

// Same list keyed by enum NAME rather than index. Automation conditions compare
// against `Status.ToString()` on the backend, so that side needs the key.
export const STATUS_KEY_SELECT_OPTIONS = ALL_STATUSES.map((s) => ({ value: s.key, label: s.label }));
